export class IndicatorIconPillarViewModel {
  icon: string;
  iconColor: string;
}
